import type { Invite, InviteAccepted, InviteAcceptRequest, SignedUp, SignupRequest } from "@shyne/shared/api";
import {SignupPayload, SignupPreflightResponse, SignupResponse} from "@/app/auth/signup/signup.entity.ts";
import {uuid} from "@/interfaces";
import {SignupRepository, type PendingSignup} from "@/repositories/signup.repository.ts";
import {InviteRepository} from "@/repositories/invite.repository.ts";

export async function emailPreflight(email: string): Promise<SignupPreflightResponse> {
    return SignupRepository.preflightEmail(email);
}

export async function resendConfirmationEmail(email: string): Promise<void> {
    return SignupRepository.resendConfirmationEmail(email);
}

export async function newSignUp(payload: SignupPayload): Promise<SignupResponse> {
    return SignupRepository.signUp(payload);
}

export async function pendingSignup(): Promise<PendingSignup> {
    return SignupRepository.pendingSignup();
}

export async function finishSignup(details: SignupRequest): Promise<SignedUp> {
    return SignupRepository.finishSignup(details);
}

export async function inviteOrgSignUp(token: uuid, payload: SignupPayload): Promise<SignupResponse> {
    return SignupRepository.signUpFromInvite(token, payload);
}

export async function readInvite(token: uuid): Promise<Invite> {
    return InviteRepository.readInvite(token);
}

export async function acceptInvite(token: uuid, acceptance: InviteAcceptRequest): Promise<InviteAccepted> {
    return SignupRepository.acceptInvite(token, acceptance);
}
